import { render, staticRenderFns } from "./ItemLabelEditor.vue?vue&type=template&id=29f1e79e&scoped=true&"
import script from "./ItemLabelEditor.vue?vue&type=script&lang=js&"
export * from "./ItemLabelEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemLabelEditor.vue?vue&type=style&index=0&id=29f1e79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1e79e",
  null
  
)

export default component.exports